import { render, staticRenderFns } from "./TextAreaSection.vue?vue&type=template&id=8bb64bbc&scoped=true"
import script from "./TextAreaSection.vue?vue&type=script&lang=js"
export * from "./TextAreaSection.vue?vue&type=script&lang=js"
import style0 from "./TextAreaSection.vue?vue&type=style&index=0&id=8bb64bbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb64bbc",
  null
  
)

export default component.exports